var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaiti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c22b38",
    d: "M30 24H0V12h30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#061a9a",
    d: "M30 12H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 9h8v6.7h-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a16",
    d: "M19 14.77c-1-.52-2.37-.84-3.97-.84a9 9 0 0 0-4.03.84v.92h8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "m13.37 11.47.78.88-.1.56-.17-.1-.15.58h-.04l-.07.3-1.33-.11.03-.95.32.1.04-.9.47.32.02-.53z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d21c33",
    d: "M15.04 13.2v1.34l-1.01-.3-.26-.37-.18-.13.1-.34.15-.6h.23l.06-.49zm-2.9-.62c.12-.14.34-.04.35 0 0 .05-.09.04-.18.13-.09.07-.06.32-.21.3-.16-.04.04-.43.04-.43m.54-.74c.16-.1.35.05.34.1 0 .04-.1 0-.2.06s-.16.3-.3.22.16-.38.16-.38m.64-.46c.17-.09.34.1.32.14 0 .05-.12-.04-.24 0s-.15.31-.28.22.2-.36.2-.36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m12.98 11 .52.32-.06.15 1.4 1.55v.13L13.4 11.5l-.2-.03zm-.75.47s.52.2.52.23l.1.18 1.9 1.54-.06.07-1.88-1.54-.27-.12zm-.55.8s.6.07.6.1c.02.02.06.16.06.16l2.2 1.2-.1.06-2.14-1.19-.25-.02z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m12.2 13.4 2.26.28-.21.26-.34.03.25.34-.12.13-.33-.37s-.1.54-.56.54-.6-.46-.6-.6q.02-.24.04-.24h-.44z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "m16.67 11.42-.81.97.03.56.21-.14.15.58h.04l.07.3 1.33-.11-.03-.95-.32.1-.04-.9-.46.32-.03-.53z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#d21c33",
    d: "M15.03 13.2v1.34l.97-.3.23-.37.17-.13-.1-.34-.16-.6-.18.14-.06-.55zm2.82-.62c-.13-.14-.35-.04-.36 0 0 .05.1.04.18.13.09.07.06.32.22.3.15-.04-.04-.43-.04-.43m-.55-.74c-.15-.1-.34.05-.34.1 0 .04.1 0 .2.06s.16.3.3.22-.16-.38-.16-.38m-.64-.46c-.17-.09-.33.1-.32.14s.13-.04.24 0 .16.31.28.22-.2-.36-.2-.36"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m17 11-.52.32.1.15-1.35 1.55v.13l1.41-1.64.17-.03zm.75.47s-.52.2-.52.23l-.1.18-1.9 1.54.06.07 1.88-1.54.28-.12zm.55.8s-.6.07-.6.1l-.05.16-2.2 1.2.09.06 2.15-1.19.24-.01z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "m17.78 13.4-2.26.28.21.26.34.03-.25.34.12.13.34-.37s.1.54.56.54c.45 0 .6-.46.6-.6q-.02-.24-.04-.24h.43z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.3 15.12s-.4 0-.82-.08c-.41-.1-.48-.25-.66-.22-.18.04-.6.2-.95.24s-.84.06-.84.06-.45-.02-.8-.06c-.34-.05-.72-.2-.9-.24s-.25.13-.67.22c-.41.09-.81.08-.81.08l.1.19-.1.1c.94 0 1.37-.3 1.37-.3.47.32 1.81.33 1.81.33s1.39-.01 1.86-.32c0 0 .45.3 1.4.28l-.1-.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M15.23 12.26c0 1-.09 1.81-.2 1.81-.1 0-.2-.8-.2-1.8 0-1.01.1-1.82.2-1.82s.2.8.2 1.81"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#d21c33",
    d: "M14.65 13.96h.77v.77h-.77z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.47 13.91c0 .1-.19.16-.41.16-.23 0-.42-.07-.42-.16s.19-.16.42-.16.4.08.4.16"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#d21c33",
    d: "M15.47 14.68c0 .1-.19.16-.41.16-.23 0-.42-.07-.42-.16s.19-.16.42-.16.4.07.4.16"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a16",
    d: "M16.72 10.11c-.15-.18-.55-.18-.82-.18-.27-.01-.4.08-.28-.04.12-.13.3-.1.5-.1q.3-.02.11-.1a.8.8 0 0 0-.61-.07c-.28.07-.45.24-.6.27-.14-.03-.33-.2-.6-.27a.8.8 0 0 0-.62.07q-.18.08.11.1c.2 0 .38-.03.5.1s-.02.03-.28.04c-.27 0-.67 0-.82.18-.16.18.13.06.28.04l.38-.03s-.38.11-.48.25.03.28.22.16c.2-.1.5-.26.65-.28 0 0-.41.18-.6.33-.18.15.01.13.15.13a.7.7 0 0 0 .4-.14c.12-.1-.07.17-.1.34-.04.17.2.13.25 0s.2-.38.2-.38-.07.37-.06.61c0 .25.09.27.15.16s.29.06.29.06.2-.18.26-.06c.06.1.13.1.13-.16.01-.24-.05-.61-.05-.61s.14.25.19.38.29.17.26 0c-.04-.17-.24-.43-.12-.34a.7.7 0 0 0 .4.14c.15 0 .34.02.16-.13s-.6-.33-.6-.33c.16.02.45.17.65.28.19.12.32-.01.22-.16s-.48-.25-.48-.25.22 0 .38.03c.15.03.43.14.28-.04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaiti);
export default __webpack_public_path__ + "static/media/haiti.b4fd841e22027ad65cd092e011c01445.svg";
export { ForwardRef as ReactComponent };